export default __webpack_public_path__ + "b8aef0d58b2f5dbfa970062692911616.png";